<div class="main-content">
    <div class="main-heading">
        <span translate>EDIT_CONTACT</span>
    </div>
    <div class="card">
        <div class="card-body ">
            <contact-form (isEdit)="myPage"></contact-form>
        </div>
    </div>
</div>